<div *ngIf="hasRunningWorkflow$ | async" class="d-flex w-100 h-100 justify-content-center panel" data-uit="workflow-panel-content">
    <div class="d-flex" (click)="openActiveWorkflowsDialog()">
        <p data-uit="workflow-panel-content-text">
            {{ 'WORKFLOW_PANEL.YOU_HAVE' | translate }}
            <span *ngIf="pendingQueue.length"> {{ pendingQueue.length }} pending</span>
            <span *ngIf="pendingQueue.length && runningQueue.length"> and</span>
            <span *ngIf="runningQueue.length"> {{ runningQueue.length }} running </span>
            <span *ngIf="pendingQueue.length + runningQueue.length === 1">{{ 'WORKFLOW_PANEL.WORKFLOW' | translate }}</span>
            <span *ngIf="pendingQueue.length + runningQueue.length > 1">{{ 'WORKFLOW_PANEL.WORKFLOWS' | translate }}</span>
        </p>
        <button
            type="button"
            class="btn btn-primary-outline btn-primary btn-sm align-self-center ms-3 px-3"
            data-uit="header-workflow-panel-view-workflows-btn"
        >
            {{ 'WORKFLOW_PANEL.VIEW_WORKFLOW' | translate }}
        </button>
    </div>
</div>
